module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.29516",
      "ably": "static-2.2",
      "data-fetching-client": "static-1.9716",
      "ably-hubspot-js": "static-2.4770",
      "atom": "static-1.5126",
      "conversations-error-reporting": "static-1.8938",
      "conversations-internal-pub-sub": "static-1.16035",
      "conversations-internal-schema": "static-1.12993",
      "conversations-message-history": "static-1.12842",
      "conversations-test-sdk": "static-1.10555",
      "conversations-visitor-experience-components": "static-1.22879",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5643",
      "hs-test-utils": "static-1.8068",
      "hubspot-dlb": "static-2.1854",
      "HubStyleTokens": "static-2.11525",
      "I18n": "static-7.1633",
      "immer": "static-1.33",
      "jasmine-immutable": "static-1.3072",
      "jasmine-runner": "static-1.6515",
      "quartz": "static-1.7093",
      "react-dlb": "static-1.80",
      "react-select-plus": "static-1.106",
      "react-transition-group": "static-2.66",
      "redux-thunk": "static-2.43",
      "sanitize": "static-1.4528",
      "StyleGuideUI": "static-3.488",
      "transmute": "static-2.85",
      "urlinator": "static-1.4589",
      "usage-tracker": "static-1.7401",
      "usage-tracker-core": "static-1.7251",
      "usage-tracker-public": "static-1.7212",
      "viral-links-lib": "static-1.7120",
      "visitor-ui-component-library": "static-1.6191",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.4864",
      "conversations-prop-types": "static-1.7504",
      "conversations-visitor-message-history": "static-1.21616",
      "cssUtils": "static-1.804",
      "enviro": "static-4.455",
      "flux-actions": "static-1.341",
      "foundations-components": "static-1.8029",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6274",
      "hubspot-url-utils": "static-1.4132",
      "immutable": "static-2.79",
      "metrics-js": "static-1.9637",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.187",
      "react-aria": "static-1.67",
      "react-dom": "static-7.85",
      "react-redux": "static-7.71",
      "react-rhumb": "static-1.16729",
      "react-utils": "static-2.5384",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.8194",
      "signup-constants": "static-1.18949",
      "styled-components": "static-2.89",
      "usage-tracker-multi": "static-1.5815",
      "visitor-ui-component-library-icons": "static-1.6002",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3440",
      "moment": "static-3.26",
      "apollo-stack-hubspot": "static-3.87",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.83",
      "quartz-config": "static-1.871",
      "quartz-core": "static-1.6312",
      "foundations-assets": "static-1.4921",
      "foundations-theming": "static-1.4476",
      "UIComponents": "static-3.8471",
      "conversations-async-data": "static-2.7714",
      "customer-data-email": "static-1.18123",
      "cv-backend-services": "static-1.1555",
      "immutable-less": "static-1.4704",
      "conversations-skeleton-state": "static-1.7300",
      "crm-events-viz-core": "static-1.33335",
      "customer-data-objects": "static-1.7727",
      "icons": "static-2.650",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.4704",
      "ui-images": "static-2.1165",
      "HeadJS": "static-2.765",
      "framer-motion": "static-1.73",
      "hs-test-utils-bend-plugin": "static-1.3179",
      "msw": "static-1.39",
      "testing-library": "static-1.153",
      "i18n-data": "static-1.222",
      "moment-timezone": "static-5.84",
      "jasmine": "static-4.4377",
      "signup-ui-url-generator": "static-2.8105",
      "HubStyle": "static-2.11832",
      "quartz-i18n": "static-1.768",
      "sassPrefix": "static-1.157",
      "bend-plugin-foundations-components": "static-1.4298",
      "floating-ui": "static-1.57",
      "foundations-theming-specialty": "static-1.2192",
      "hs-story-utils": "static-1.9475",
      "react-create-root-preference": "static-1.31",
      "react-virtualized": "static-2.100",
      "tanstack-table": "static-1.56",
      "trellis-assets": "static-1.2073",
      "ui-fonts": "static-1.787",
      "hs-locale-management": "static-1.121",
      "csstype": "static-1.50",
      "quartz-head": "static-1.758",
      "quick-fetch": "static-1.3958",
      "web-vitals": "static-1.7",
      "quartz-routing": "static-1.523",
      "usage-tracker-anonymous": "static-1.5818",
      "bender-build-tools": "static-1.3254",
      "dispatcher": "static-1.137",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.839",
      "hubspotter-http": "static-1.4691",
      "mobile-manifest-mixins": "static-1.539",
      "module-federation": "static-1.24",
      "quartz-auth": "static-1.768",
      "quartz-test": "static-1.768",
      "quartz-tracking": "static-1.472",
      "usage-tracker-container": "static-1.7391",
      "bend-plugin-foundations-theming": "static-1.2959",
      "foundations-theming-base": "static-1.3461",
      "stylex": "static-1.34",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4703",
      "customer-data-ui-utilities": "static-1.9877",
      "FileManagerCore": "static-1.39253",
      "FileManagerLib": "static-1.39394",
      "hubspot-apollo-client": "static-1.4929",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.526",
      "timezone-utils": "static-2.5295",
      "ui-gdpr-components": "static-1.10401",
      "ts-schema": "static-1.4120",
      "ai-components-ui-library": "static-1.9095",
      "avatar-components": "static-1.2550",
      "content-assistance-lib": "static-1.7830",
      "crm-component-utils": "static-1.39212",
      "crm-display-components": "static-1.24962",
      "crm-fe-perf": "static-1.22954",
      "crm-links": "static-1.6356",
      "crm-message-bus": "static-1.43101",
      "crm-search-service-types": "static-1.1206",
      "crm-source-interpretation-lib": "static-1.5394",
      "customer-data-communicator": "static-1.45673",
      "customer-data-filters-ui": "static-1.39975",
      "customer-data-objects-ui-components": "static-1.13082",
      "customer-data-properties": "static-1.51746",
      "customer-data-rte": "static-1.33133",
      "draft-plugins": "static-2.21764",
      "file-manager-components": "static-1.23754",
      "framework-data-schema-resolvers": "static-1.6939",
      "frontend-preferences-client": "static-1.7978",
      "hubspot-prosemirror": "static-1.18371",
      "object-comments-thread-lib": "static-1.10800",
      "prosemirror-user-and-team-at-mentions": "static-1.707",
      "reference-resolvers-lite": "static-1.8147",
      "ui-addon-upgrades": "static-9.18067",
      "universal-associations-select": "static-1.11099",
      "universal-record-utils-lib": "static-1.1055",
      "wootric-nps": "static-1.7022",
      "inbound-db-properties-service-client": "static-1.3886",
      "property-translator": "static-1.5450",
      "bend-plugin-chirp-manifest": "static-1.114",
      "chirp-fetch": "static-1.1939",
      "hub-http-shared-msw-handlers": "static-1.10086",
      "hubspotter-http-shared-msw-handlers": "static-1.10084",
      "usage-tracker-session-replay": "static-1.5087",
      "react-dnd-compat": "static-1.4665",
      "audio-components": "static-1.5993",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29390",
      "FileManagerImages": "static-1.36905",
      "foundations-components-legacy": "static-1.1054",
      "immerable": "static-1.4205",
      "react-colorpicker": "static-2.10260",
      "ui-universal-auth": "static-1.9040",
      "video-components": "static-1.13459",
      "video-data-lib": "static-1.35115",
      "video-embed": "static-1.35949",
      "hubspot-apollo-cache": "static-1.388",
      "chatspot-core": "static-1.21515",
      "ContentUtils": "static-1.68513",
      "copilot-toolkit": "static-1.11269",
      "superstore": "static-1.4812",
      "ui-addon-video-player": "static-1.8755",
      "ui-coaching-tips": "static-1.28702",
      "card-properties-lib": "static-1.44348",
      "commerce-subscription-lib": "static-1.37265",
      "crm-actions": "static-1.6388",
      "crm-cards-sdk": "static-1.43738",
      "customer-data-properties-shared-msw-handlers": "static-1.9413",
      "customer-data-property-utils": "static-1.8142",
      "customer-data-tracking": "static-1.6941",
      "hs-resources": "static-1.219",
      "inbound-db-meta-service-client": "static-1.3626",
      "pulse": "static-1.637",
      "framework-data-table": "static-2.12033",
      "location-customization-utils-lib": "static-1.9408",
      "restore-request-side-panel-lib": "static-1.1032",
      "calling-error-reporting": "static-1.31362",
      "calling-internal-common": "static-1.31355",
      "calling-usage-tracker": "static-1.6593",
      "crm_data": "static-4.92120",
      "customer-data-content": "static-1.27382",
      "draft-content-plugins": "static-1.28405",
      "draft-convert": "static-2.74",
      "draft-extend": "static-3.76",
      "draft-js": "static-5.79",
      "draft-signature-plugin": "static-1.24206",
      "EmailSignatureEditor": "static-1.24485",
      "hubspot-prosemirror-plugins": "static-1.18363",
      "integration-settings-components": "static-1.15616",
      "integrations-lib": "static-1.16328",
      "integrations-tracking-lib": "static-1.5654",
      "native-integrations-shared-strings": "static-1.7833",
      "nav-meta": "static-1.29802",
      "onboarding-scopes": "static-1.6513",
      "outreach-assistant-email-generation": "static-1.6325",
      "prosemirror-copilot": "static-1.11744",
      "prosemirror": "static-1.13",
      "quotes-client-types": "static-1.38298",
      "reference-resolvers": "static-1.8223",
      "rich-text-lib": "static-1.19919",
      "sales-email-signature-service-client": "static-1.3898",
      "sequences-lib": "static-1.8131",
      "ui-addon-i18n": "static-1.11203",
      "ui-addon-iframeable": "static-1.9111",
      "ui-business-units-lib": "static-1.9109",
      "ui-shepherd-react": "static-3.10263",
      "user-context": "static-1.5159",
      "whatsapp-sending-lib": "static-1.5869",
      "events-data-lib": "static-1.279",
      "customer-data-filters-ui-msw-helpers": "static-1.22410",
      "customer-data-reference-ui-components": "static-1.13219",
      "FormUrlGenerator": "static-2.4772",
      "framework-builder-read-service-client": "static-1.4045",
      "framework-data-schema-quick-fetch": "static-1.6844",
      "multi-account-reference-resolvers": "static-1.1032",
      "onboarding-tours": "static-1.16700",
      "reporting-datasets-permissions-lib": "static-1.13824",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21624",
      "calling-global-api": "static-1.64688",
      "calling-lifecycle-internal": "static-1.66070",
      "calling-lifecycle-messages": "static-1.58364",
      "commerce-products-lib": "static-1.9747",
      "conditional-properties-service-client": "static-1.3838",
      "crm-pipelines-api-client-types": "static-1.4180",
      "external-options-client-types": "static-1.4199",
      "google-libphonenumber": "static-1.39",
      "inbounddb-objects-service-types": "static-1.4263",
      "meetings-icalendar-utils-lib": "static-1.684",
      "multi-currency-client-types": "static-1.3732",
      "object-builder-ui-client": "static-1.48918",
      "pipeline-validation-client-types": "static-1.4006",
      "property-value-citations": "static-1.2360",
      "smart-property-lib": "static-1.7371",
      "tiered-pricing": "static-1.1330",
      "zustand": "static-1.74",
      "ui-addon-form-validation": "static-1.11041",
      "video-components-external": "static-1.11457",
      "batch-promise": "static-1.1593",
      "fdsr-migration-layer": "static-1.58",
      "persist-promise": "static-1.3750",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.25524",
      "knowledge-content-types": "static-1.8516",
      "payment-link-components": "static-1.23646",
      "ui-addon-emoji-picker": "static-1.9938",
      "call-summary": "static-1.39378",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10232",
      "laboratory-lib": "static-3.7207",
      "merchandise-lib": "static-1.265",
      "purchase-motions-components": "static-1.6005",
      "crm-object-search-query-utilities": "static-1.9697",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "unified-auth-core-lib": "static-1.836",
      "content-icons-ui": "static-1.2239",
      "social-insights-client-types": "static-1.22239",
      "outpost": "static-1.4228",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4864",
      "underscore": "static-1.8",
      "breeze-engine-lib": "static-1.833",
      "magpie-lib": "static-1.5585",
      "magpie-types": "static-1.5045",
      "simple-logging-lib": "static-1.3102",
      "growth-onboarding-feedback-components": "static-1.6631",
      "customer-data-sidebar": "static-2.46157",
      "enrichment-properties-lib": "static-1.16489",
      "ui-addon-draggable-compat": "static-2.4310",
      "commerce-billing-lib": "static-1.19238",
      "commerce-shared-components-lib": "static-1.18658",
      "commerce-tools-ui-lib": "static-1.10512",
      "event-emitter": "static-1.999",
      "bend-plugin-pulse": "static-1.140",
      "fast-json-patch": "static-1.64",
      "customer-data-associations": "static-1.7378",
      "reporting-data": "static-1.67774",
      "tanstack-virtual": "static-1.31",
      "ui-addon-draggable": "static-3.4814",
      "crm-record-cards-service-types": "static-1.3630",
      "self-service-api": "static-1.10298",
      "crm_universal": "static-1.22095",
      "SalesContentIndexUI": "static-3.9323",
      "content-embed-lib": "static-1.7390",
      "data-model-builder-lib": "static-1.12494",
      "remote-ui": "static-1.66",
      "ui-components-test-utils": "static-1.5662",
      "ui-extensions-remote-renderer": "static-1.17176",
      "universal-page-editor-lib": "static-1.3067",
      "integrations-error-boundary-lib": "static-1.13743",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10416",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.554",
      "messaging-types-lib": "static-1.46157",
      "ai-addon-copilot-preview": "static-1.8307",
      "copilot-plugins": "static-1.11242",
      "data-token-picker": "static-1.16494",
      "sequences-client-types-lib": "static-1.7988",
      "foundations-components-test-utils": "static-1.5512",
      "navigation-messaging": "static-1.7492",
      "getting-started-shared-tasks": "static-1.18569",
      "getting-started-shared-tasks-store": "static-1.17687",
      "onboarding-tours-utils": "static-1.766",
      "messaging-usage-based-billing-components-lib": "static-1.1282",
      "whatsapp-management-lib": "static-1.9028",
      "growth-data-modal": "static-1.5507",
      "growth-onboarding-confetti": "static-1.3118",
      "growth-onboarding-next-action-utils": "static-1.2066",
      "navigation-components": "static-1.18165",
      "onboarding-tours-client": "static-1.4914",
      "ui-shepherd-tracker": "static-1.7644",
      "shared-worker-versioning": "static-1.11088",
      "voice-sms-access-library": "static-1.1204",
      "commerce-permissions": "static-1.825",
      "products-iframe-lib": "static-1.8076",
      "products-ui-components-shared-msw-handlers": "static-1.10468",
      "data-agent-kit": "static-1.274",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10169",
      "fsm": "static-1.3782",
      "policy-lib": "static-1.6828",
      "react-tinymce": "static-1.55385",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54511",
      "tinymce-plugins": "static-1.57625",
      "tinymce-themes": "static-1.56481",
      "content-media-composition-data-lib": "static-1.12524",
      "content-media-compositions": "static-2.16531",
      "idb-keyval": "static-1.45",
      "media-bridge-lib": "static-1.19017",
      "seat-types-lib": "static-1.136",
      "ui-addon-opt": "static-4.8414",
      "commerce-tours-lib": "static-1.6196",
      "growth-onboarding-reliability": "static-1.5132",
      "sales-checkout-service-client": "static-1.3689",
      "calling-cross-tab-library": "static-1.19340",
      "calling-lifecycle-usage-tracker": "static-1.8842",
      "purchase-motions-api": "static-1.6008",
      "breeze-engine-core": "static-1.111",
      "highlight.js": "static-1.80",
      "reactive-lib": "static-1.775",
      "card-payment-highlight-lib": "static-1.37317",
      "card-subscription-highlight-lib": "static-1.39688",
      "commerce-contract-lib": "static-1.12268",
      "invoices-highlight-card-lib": "static-1.54876",
      "orders-highlight-card-lib": "static-1.21607",
      "products-highlight-card-lib": "static-1.18030",
      "quotes-highlight-card-lib": "static-1.72208",
      "usage-based-billing-components-lib": "static-1.9170",
      "utility-belt": "static-1.2586",
      "payments-enrollment-embed-lib": "static-1.23040",
      "stripe-embedded-components": "static-1.7596",
      "growth-onboarding-empty-states": "static-1.5829",
      "InboxConnectUtils": "static-4.14954",
      "payments-post-enroll-local-storage-lib": "static-1.5160",
      "qrcode-generator": "static-1.70",
      "trials-service-types": "static-1.3957",
      "reporting-client-types": "static-1.2525",
      "react-flip-move": "static-1.72",
      "FireAlarmUi": "static-1.4553",
      "sales-templates-service-types-lib": "static-1.4210",
      "ui-asset-management-lib": "static-1.11103",
      "association-settings-lib": "static-1.10421",
      "collaboration-sidebar": "static-1.57958",
      "conditional-property-settings-modal": "static-1.12558",
      "data-model-commons-lib": "static-1.12758",
      "ExportDialog": "static-6.10437",
      "final-form": "static-1.71",
      "html-to-image": "static-1.55",
      "nudge-client-utils": "static-1.2692",
      "object-definition-builder-lib": "static-1.7155",
      "property-management-iframe": "static-1.13326",
      "property-usages-lib": "static-1.5495",
      "reactflow": "static-1.65",
      "simple-data-table": "static-1.2920",
      "used-in-list-lib": "static-1.7010",
      "visual-association": "static-1.5936",
      "highcharts": "static-8.105",
      "reporting-visualizations": "static-1.59850",
      "ui-extensibility-client-types": "static-1.3977",
      "ads-unified-auth-lib": "static-1.27",
      "google-sheets-integration-lib": "static-1.385",
      "microsoft-drive-integration-lib": "static-1.519",
      "slack-ui-library": "static-1.10443",
      "automation-platform-service-types": "static-1.2603",
      "ContentData": "static-1.68588",
      "email-portal-health-service-types": "static-1.1030",
      "marketing-email-service-types": "static-1.1938",
      "ai-rendering-library": "static-1.10346",
      "ai-settings-ui-library": "static-1.7965",
      "ui-brand-identity-lib": "static-1.15478",
      "messaging-shared-utils-lib": "static-1.731",
      "messaging-user-info-utils-lib": "static-1.901",
      "content-whatsapp-service-types": "static-1.420",
      "marketing-platform-lib": "static-1.6911",
      "short-messages-app-service-client": "static-1.4022",
      "ui-tool-access": "static-1.10200",
      "onboarding-data-sync-lib": "static-1.2041",
      "growth-onboarding-next-action-components": "static-1.2094",
      "user-context-client": "static-1.4655",
      "nest": "static-1.283",
      "calling-orchestration-schema": "static-1.35981",
      "sales-views-client-types": "static-1.4309",
      "trellis-story-utils": "static-1.4565",
      "storybook-react": "static-1.34",
      "hub-http-contrib": "static-1.3093",
      "interframe": "static-3.4811",
      "tinymce-data": "static-1.40596",
      "ui-addon-sales-email": "static-1.5262",
      "codemirror": "static-5.96",
      "layout-dnd-components": "static-1.12542",
      "layout-dnd-utils": "static-1.11517",
      "react-codemirror": "static-1.10679",
      "NamespacedHubStyle": "static-2.9099",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40265",
      "accounting-integrations-ui-components": "static-1.7144",
      "invoices-ui-lib": "static-1.54892",
      "commerce-products-api": "static-1.2372",
      "invoices-iframe-lib": "static-1.56950",
      "quotes-modal-lib": "static-1.102886",
      "quotes-ui-lib": "static-1.80929",
      "platform-infra-nav-components": "static-1.7712",
      "reporting-ui-components": "static-2.65045",
      "subscription-experience-data-types": "static-1.15000",
      "marketplace-ui-apps-core": "static-1.18482",
      "stripe-connect-js": "static-1.69",
      "ui-addon-react-router-dom": "static-1.9593",
      "nested-table": "static-1.278",
      "chatspot-widget-iframe": "static-1.21506",
      "collaboration-sidebar-common": "static-1.2755",
      "crm-properties-common-lib": "static-1.5938",
      "nudge-custom-function-registry": "static-1.2449",
      "nudge-renderer-utils": "static-1.2768",
      "whisper-core-api": "static-1.6768",
      "property-management-common": "static-1.5614",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15208",
      "advanced-menus-lib": "static-1.12143",
      "ui-memberships-settings-lib": "static-1.34184",
      "breeze-onboarding-components": "static-1.136",
      "embedded-academy-lib": "static-1.14508",
      "reporting-action-components": "static-1.41440",
      "reporting-snowflake": "static-1.56392",
      "meetings-connect-utils-lib": "static-1.7656",
      "diff-match-patch": "static-1.7",
      "layout-data-lib": "static-1.9842",
      "browser-eslint": "static-2.57",
      "commerce-tax-lib": "static-1.581",
      "price-books-api": "static-1.999",
      "price-books-components": "static-1.1057",
      "property-description-translator": "static-1.3894",
      "ramp-editor": "static-1.264",
      "commerce-analytics-service-client": "static-1.3677",
      "totals-ui-components": "static-1.23747",
      "reporting-plugins": "static-1.10400",
      "reporting-reports": "static-1.67452",
      "edison-service-client-types": "static-1.440",
      "developer-experience-shared-components": "static-1.10564",
      "marketplace-ui-client-types": "static-1.17357",
      "marketplace-ui-common": "static-1.19950",
      "ui-addon-integrations-directory-panel": "static-2.8052",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.223",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15207",
      "simple-menus-lib": "static-1.16724",
      "academy-common-lib": "static-1.13968",
      "dashboard-lib": "static-1.81736",
      "share-with-third-party-component-lib": "static-1.8756",
      "line-items-api": "static-1.773",
      "commerce-totals-service-types": "static-1.3859",
      "campaign-roi-lib": "static-1.9256",
      "apps-service-types": "static-1.3910",
      "oauth-service-types": "static-1.4302",
      "academy-service-client": "static-1.3734",
      "croppie": "static-2.10",
      "trellis-ecosystem": "static-1.7232",
      "redux-actions": "static-3.7"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.29516",
      "ably": "/ably/static-2.2",
      "data-fetching-client": "/data-fetching-client/static-1.9716",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4770",
      "atom": "/atom/static-1.5126",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.8938",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16035",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12993",
      "conversations-message-history": "/conversations-message-history/static-1.12842",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10555",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.22879",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5643",
      "hs-test-utils": "/hs-test-utils/static-1.8068",
      "hubspot-dlb": "/hubspot-dlb/static-2.1854",
      "HubStyleTokens": "/HubStyleTokens/static-2.11525",
      "I18n": "/I18n/static-7.1633",
      "immer": "/immer/static-1.33",
      "jasmine-immutable": "/jasmine-immutable/static-1.3072",
      "jasmine-runner": "/jasmine-runner/static-1.6515",
      "quartz": "/quartz/static-1.7093",
      "react-dlb": "/react-dlb/static-1.80",
      "react-select-plus": "/react-select-plus/static-1.106",
      "react-transition-group": "/react-transition-group/static-2.66",
      "redux-thunk": "/redux-thunk/static-2.43",
      "sanitize": "/sanitize/static-1.4528",
      "StyleGuideUI": "/StyleGuideUI/static-3.488",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4589",
      "usage-tracker": "/usage-tracker/static-1.7401",
      "usage-tracker-core": "/usage-tracker-core/static-1.7251",
      "usage-tracker-public": "/usage-tracker-public/static-1.7212",
      "viral-links-lib": "/viral-links-lib/static-1.7120",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6191",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.4864",
      "conversations-prop-types": "/conversations-prop-types/static-1.7504",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.21616",
      "cssUtils": "/cssUtils/static-1.804",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.341",
      "foundations-components": "/foundations-components/static-1.8029",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6274",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
      "immutable": "/immutable/static-2.79",
      "metrics-js": "/metrics-js/static-1.9637",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.187",
      "react-aria": "/react-aria/static-1.67",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.71",
      "react-rhumb": "/react-rhumb/static-1.16729",
      "react-utils": "/react-utils/static-2.5384",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.8194",
      "signup-constants": "/signup-constants/static-1.18949",
      "styled-components": "/styled-components/static-2.89",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.5815",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6002",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3440",
      "moment": "/moment/static-3.26",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.83",
      "quartz-config": "/quartz-config/static-1.871",
      "quartz-core": "/quartz-core/static-1.6312",
      "foundations-assets": "/foundations-assets/static-1.4921",
      "foundations-theming": "/foundations-theming/static-1.4476",
      "UIComponents": "/UIComponents/static-3.8471",
      "conversations-async-data": "/conversations-async-data/static-2.7714",
      "customer-data-email": "/customer-data-email/static-1.18123",
      "cv-backend-services": "/cv-backend-services/static-1.1555",
      "immutable-less": "/immutable-less/static-1.4704",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7300",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33335",
      "customer-data-objects": "/customer-data-objects/static-1.7727",
      "icons": "/icons/static-2.650",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.4704",
      "ui-images": "/ui-images/static-2.1165",
      "HeadJS": "/HeadJS/static-2.765",
      "framer-motion": "/framer-motion/static-1.73",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3179",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.153",
      "i18n-data": "/i18n-data/static-1.222",
      "moment-timezone": "/moment-timezone/static-5.84",
      "jasmine": "/jasmine/static-4.4377",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8105",
      "HubStyle": "/HubStyle/static-2.11832",
      "quartz-i18n": "/quartz-i18n/static-1.768",
      "sassPrefix": "/sassPrefix/static-1.157",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4298",
      "floating-ui": "/floating-ui/static-1.57",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2192",
      "hs-story-utils": "/hs-story-utils/static-1.9475",
      "react-create-root-preference": "/react-create-root-preference/static-1.31",
      "react-virtualized": "/react-virtualized/static-2.100",
      "tanstack-table": "/tanstack-table/static-1.56",
      "trellis-assets": "/trellis-assets/static-1.2073",
      "ui-fonts": "/ui-fonts/static-1.787",
      "hs-locale-management": "/hs-locale-management/static-1.121",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.758",
      "quick-fetch": "/quick-fetch/static-1.3958",
      "web-vitals": "/web-vitals/static-1.7",
      "quartz-routing": "/quartz-routing/static-1.523",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5818",
      "bender-build-tools": "/bender-build-tools/static-1.3254",
      "dispatcher": "/dispatcher/static-1.137",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.839",
      "hubspotter-http": "/hubspotter-http/static-1.4691",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.539",
      "module-federation": "/module-federation/static-1.24",
      "quartz-auth": "/quartz-auth/static-1.768",
      "quartz-test": "/quartz-test/static-1.768",
      "quartz-tracking": "/quartz-tracking/static-1.472",
      "usage-tracker-container": "/usage-tracker-container/static-1.7391",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2959",
      "foundations-theming-base": "/foundations-theming-base/static-1.3461",
      "stylex": "/stylex/static-1.34",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4703",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9877",
      "FileManagerCore": "/FileManagerCore/static-1.39253",
      "FileManagerLib": "/FileManagerLib/static-1.39394",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4929",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.526",
      "timezone-utils": "/timezone-utils/static-2.5295",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10401",
      "ts-schema": "/ts-schema/static-1.4120",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9095",
      "avatar-components": "/avatar-components/static-1.2550",
      "content-assistance-lib": "/content-assistance-lib/static-1.7830",
      "crm-component-utils": "/crm-component-utils/static-1.39212",
      "crm-display-components": "/crm-display-components/static-1.24962",
      "crm-fe-perf": "/crm-fe-perf/static-1.22954",
      "crm-links": "/crm-links/static-1.6356",
      "crm-message-bus": "/crm-message-bus/static-1.43101",
      "crm-search-service-types": "/crm-search-service-types/static-1.1206",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5394",
      "customer-data-communicator": "/customer-data-communicator/static-1.45673",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39975",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13082",
      "customer-data-properties": "/customer-data-properties/static-1.51746",
      "customer-data-rte": "/customer-data-rte/static-1.33133",
      "draft-plugins": "/draft-plugins/static-2.21764",
      "file-manager-components": "/file-manager-components/static-1.23754",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6939",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7978",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18371",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.10800",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.707",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8147",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18067",
      "universal-associations-select": "/universal-associations-select/static-1.11099",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1055",
      "wootric-nps": "/wootric-nps/static-1.7022",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3886",
      "property-translator": "/property-translator/static-1.5450",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.114",
      "chirp-fetch": "/chirp-fetch/static-1.1939",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10086",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10084",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5087",
      "react-dnd-compat": "/react-dnd-compat/static-1.4665",
      "audio-components": "/audio-components/static-1.5993",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29390",
      "FileManagerImages": "/FileManagerImages/static-1.36905",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1054",
      "immerable": "/immerable/static-1.4205",
      "react-colorpicker": "/react-colorpicker/static-2.10260",
      "ui-universal-auth": "/ui-universal-auth/static-1.9040",
      "video-components": "/video-components/static-1.13459",
      "video-data-lib": "/video-data-lib/static-1.35115",
      "video-embed": "/video-embed/static-1.35949",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.388",
      "chatspot-core": "/chatspot-core/static-1.21515",
      "ContentUtils": "/ContentUtils/static-1.68513",
      "copilot-toolkit": "/copilot-toolkit/static-1.11269",
      "superstore": "/superstore/static-1.4812",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8755",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.28702",
      "card-properties-lib": "/card-properties-lib/static-1.44348",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37265",
      "crm-actions": "/crm-actions/static-1.6388",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.43738",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9413",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8142",
      "customer-data-tracking": "/customer-data-tracking/static-1.6941",
      "hs-resources": "/hs-resources/static-1.219",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3626",
      "pulse": "/pulse/static-1.637",
      "framework-data-table": "/framework-data-table/static-2.12033",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9408",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1032",
      "calling-error-reporting": "/calling-error-reporting/static-1.31362",
      "calling-internal-common": "/calling-internal-common/static-1.31355",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6593",
      "crm_data": "/crm_data/static-4.92120",
      "customer-data-content": "/customer-data-content/static-1.27382",
      "draft-content-plugins": "/draft-content-plugins/static-1.28405",
      "draft-convert": "/draft-convert/static-2.74",
      "draft-extend": "/draft-extend/static-3.76",
      "draft-js": "/draft-js/static-5.79",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24206",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24485",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18363",
      "integration-settings-components": "/integration-settings-components/static-1.15616",
      "integrations-lib": "/integrations-lib/static-1.16328",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5654",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7833",
      "nav-meta": "/nav-meta/static-1.29802",
      "onboarding-scopes": "/onboarding-scopes/static-1.6513",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6325",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.11744",
      "prosemirror": "/prosemirror/static-1.13",
      "quotes-client-types": "/quotes-client-types/static-1.38298",
      "reference-resolvers": "/reference-resolvers/static-1.8223",
      "rich-text-lib": "/rich-text-lib/static-1.19919",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3898",
      "sequences-lib": "/sequences-lib/static-1.8131",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11203",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9111",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9109",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10263",
      "user-context": "/user-context/static-1.5159",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.5869",
      "events-data-lib": "/events-data-lib/static-1.279",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22410",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13219",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4772",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4045",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6844",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1032",
      "onboarding-tours": "/onboarding-tours/static-1.16700",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13824",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21624",
      "calling-global-api": "/calling-global-api/static-1.64688",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66070",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58364",
      "commerce-products-lib": "/commerce-products-lib/static-1.9747",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3838",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4180",
      "external-options-client-types": "/external-options-client-types/static-1.4199",
      "google-libphonenumber": "/google-libphonenumber/static-1.39",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4263",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.684",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3732",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.48918",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4006",
      "property-value-citations": "/property-value-citations/static-1.2360",
      "smart-property-lib": "/smart-property-lib/static-1.7371",
      "tiered-pricing": "/tiered-pricing/static-1.1330",
      "zustand": "/zustand/static-1.74",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11041",
      "video-components-external": "/video-components-external/static-1.11457",
      "batch-promise": "/batch-promise/static-1.1593",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.58",
      "persist-promise": "/persist-promise/static-1.3750",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.25524",
      "knowledge-content-types": "/knowledge-content-types/static-1.8516",
      "payment-link-components": "/payment-link-components/static-1.23646",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9938",
      "call-summary": "/call-summary/static-1.39378",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10232",
      "laboratory-lib": "/laboratory-lib/static-3.7207",
      "merchandise-lib": "/merchandise-lib/static-1.265",
      "purchase-motions-components": "/purchase-motions-components/static-1.6005",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.9697",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.836",
      "content-icons-ui": "/content-icons-ui/static-1.2239",
      "social-insights-client-types": "/social-insights-client-types/static-1.22239",
      "outpost": "/outpost/static-1.4228",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4864",
      "underscore": "/underscore/static-1.8",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.833",
      "magpie-lib": "/magpie-lib/static-1.5585",
      "magpie-types": "/magpie-types/static-1.5045",
      "simple-logging-lib": "/simple-logging-lib/static-1.3102",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6631",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46157",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16489",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4310",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19238",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18658",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10512",
      "event-emitter": "/event-emitter/static-1.999",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.140",
      "fast-json-patch": "/fast-json-patch/static-1.64",
      "customer-data-associations": "/customer-data-associations/static-1.7378",
      "reporting-data": "/reporting-data/static-1.67774",
      "tanstack-virtual": "/tanstack-virtual/static-1.31",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4814",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3630",
      "self-service-api": "/self-service-api/static-1.10298",
      "crm_universal": "/crm_universal/static-1.22095",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9323",
      "content-embed-lib": "/content-embed-lib/static-1.7390",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12494",
      "remote-ui": "/remote-ui/static-1.66",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5662",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17176",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3067",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13743",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10416",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.554",
      "messaging-types-lib": "/messaging-types-lib/static-1.46157",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8307",
      "copilot-plugins": "/copilot-plugins/static-1.11242",
      "data-token-picker": "/data-token-picker/static-1.16494",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7988",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5512",
      "navigation-messaging": "/navigation-messaging/static-1.7492",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18569",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17687",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.766",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1282",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9028",
      "growth-data-modal": "/growth-data-modal/static-1.5507",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3118",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2066",
      "navigation-components": "/navigation-components/static-1.18165",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4914",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7644",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11088",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1204",
      "commerce-permissions": "/commerce-permissions/static-1.825",
      "products-iframe-lib": "/products-iframe-lib/static-1.8076",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10468",
      "data-agent-kit": "/data-agent-kit/static-1.274",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10169",
      "fsm": "/fsm/static-1.3782",
      "policy-lib": "/policy-lib/static-1.6828",
      "react-tinymce": "/react-tinymce/static-1.55385",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54511",
      "tinymce-plugins": "/tinymce-plugins/static-1.57625",
      "tinymce-themes": "/tinymce-themes/static-1.56481",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12524",
      "content-media-compositions": "/content-media-compositions/static-2.16531",
      "idb-keyval": "/idb-keyval/static-1.45",
      "media-bridge-lib": "/media-bridge-lib/static-1.19017",
      "seat-types-lib": "/seat-types-lib/static-1.136",
      "ui-addon-opt": "/ui-addon-opt/static-4.8414",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6196",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5132",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3689",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19340",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.8842",
      "purchase-motions-api": "/purchase-motions-api/static-1.6008",
      "breeze-engine-core": "/breeze-engine-core/static-1.111",
      "highlight.js": "/highlight.js/static-1.80",
      "reactive-lib": "/reactive-lib/static-1.775",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37317",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39688",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.12268",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54876",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21607",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18030",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72208",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9170",
      "utility-belt": "/utility-belt/static-1.2586",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23040",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7596",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5829",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.14954",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5160",
      "qrcode-generator": "/qrcode-generator/static-1.70",
      "trials-service-types": "/trials-service-types/static-1.3957",
      "reporting-client-types": "/reporting-client-types/static-1.2525",
      "react-flip-move": "/react-flip-move/static-1.72",
      "FireAlarmUi": "/FireAlarmUi/static-1.4553",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4210",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11103",
      "association-settings-lib": "/association-settings-lib/static-1.10421",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.57958",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12558",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.12758",
      "ExportDialog": "/ExportDialog/static-6.10437",
      "final-form": "/final-form/static-1.71",
      "html-to-image": "/html-to-image/static-1.55",
      "nudge-client-utils": "/nudge-client-utils/static-1.2692",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7155",
      "property-management-iframe": "/property-management-iframe/static-1.13326",
      "property-usages-lib": "/property-usages-lib/static-1.5495",
      "reactflow": "/reactflow/static-1.65",
      "simple-data-table": "/simple-data-table/static-1.2920",
      "used-in-list-lib": "/used-in-list-lib/static-1.7010",
      "visual-association": "/visual-association/static-1.5936",
      "highcharts": "/highcharts/static-8.105",
      "reporting-visualizations": "/reporting-visualizations/static-1.59850",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3977",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.27",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.385",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.519",
      "slack-ui-library": "/slack-ui-library/static-1.10443",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2603",
      "ContentData": "/ContentData/static-1.68588",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1030",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1938",
      "ai-rendering-library": "/ai-rendering-library/static-1.10346",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7965",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15478",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.731",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.901",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.420",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6911",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4022",
      "ui-tool-access": "/ui-tool-access/static-1.10200",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2041",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2094",
      "user-context-client": "/user-context-client/static-1.4655",
      "nest": "/nest/static-1.283",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35981",
      "sales-views-client-types": "/sales-views-client-types/static-1.4309",
      "trellis-story-utils": "/trellis-story-utils/static-1.4565",
      "storybook-react": "/storybook-react/static-1.34",
      "hub-http-contrib": "/hub-http-contrib/static-1.3093",
      "interframe": "/interframe/static-3.4811",
      "tinymce-data": "/tinymce-data/static-1.40596",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5262",
      "codemirror": "/codemirror/static-5.96",
      "layout-dnd-components": "/layout-dnd-components/static-1.12542",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11517",
      "react-codemirror": "/react-codemirror/static-1.10679",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9099",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40265",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7144",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.54892",
      "commerce-products-api": "/commerce-products-api/static-1.2372",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56950",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.102886",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.80929",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7712",
      "reporting-ui-components": "/reporting-ui-components/static-2.65045",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15000",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18482",
      "stripe-connect-js": "/stripe-connect-js/static-1.69",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9593",
      "nested-table": "/nested-table/static-1.278",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21506",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2755",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5938",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2449",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2768",
      "whisper-core-api": "/whisper-core-api/static-1.6768",
      "property-management-common": "/property-management-common/static-1.5614",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15208",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12143",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34184",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.136",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.14508",
      "reporting-action-components": "/reporting-action-components/static-1.41440",
      "reporting-snowflake": "/reporting-snowflake/static-1.56392",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7656",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "layout-data-lib": "/layout-data-lib/static-1.9842",
      "browser-eslint": "/browser-eslint/static-2.57",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.581",
      "price-books-api": "/price-books-api/static-1.999",
      "price-books-components": "/price-books-components/static-1.1057",
      "property-description-translator": "/property-description-translator/static-1.3894",
      "ramp-editor": "/ramp-editor/static-1.264",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3677",
      "totals-ui-components": "/totals-ui-components/static-1.23747",
      "reporting-plugins": "/reporting-plugins/static-1.10400",
      "reporting-reports": "/reporting-reports/static-1.67452",
      "edison-service-client-types": "/edison-service-client-types/static-1.440",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10564",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17357",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.19950",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8052",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.223",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15207",
      "simple-menus-lib": "/simple-menus-lib/static-1.16724",
      "academy-common-lib": "/academy-common-lib/static-1.13968",
      "dashboard-lib": "/dashboard-lib/static-1.81736",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8756",
      "line-items-api": "/line-items-api/static-1.773",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3859",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9256",
      "apps-service-types": "/apps-service-types/static-1.3910",
      "oauth-service-types": "/oauth-service-types/static-1.4302",
      "academy-service-client": "/academy-service-client/static-1.3734",
      "croppie": "/croppie/static-2.10",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7232",
      "redux-actions": "/redux-actions/static-3.7"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29516",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};